import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './baseQuery';

export const baseApi = createApi({
  baseQuery,
  tagTypes: ['Users', 'Shops', 'ShopCategories', 'Auth'],
  endpoints: () => ({}),
});

export const {
  middleware: baseApiMiddleware,
  reducer: baseApiReducer,
  reducerPath: baseApiReducerPath,
} = baseApi; 